import React from 'react'
import './privacy-policy.css'

export default function PrivacyPolicy() {
  return (
    <div className="pp-page">
      <header className="pp-header">
        <h1 className="pp-header__title">Privacy Policy</h1>
      </header>

      <main className="pp-content-wrap">
        <article className="pp-content">
          <p className="pp-updated">Last Updated: 2026</p>

          <p>
            <strong>Leadszora</strong> (&ldquo;we&rdquo;, &ldquo;our&rdquo;, &ldquo;us&rdquo;)
            operates a B2B data-intelligence platform that provides access to
            company information, business contact information, phone data, and
            related business insights. We are committed to protecting your privacy
            and handling your personal information responsibly.
          </p>

          <h2>Information We Collect</h2>
          <p>We may collect the following types of information:</p>

          <h3>1. Information You Provide</h3>
          <ul>
            <li>Name, Business Contact Information, phone number</li>
            <li>Account details</li>
            <li>Payment information (processed securely through third-party payment processors)</li>
          </ul>

          <h3>2. AI-Assisted Collected Information</h3>
          <ul>
            <li>IP address</li>
            <li>Device and browser details</li>
            <li>Usage statistics</li>
            <li>Cookies and tracking technologies</li>
          </ul>

          <h3>3. Data Accessed Through the Platform</h3>
          <p>You may access business data such as:</p>
          <ul>
            <li>Company names</li>
            <li>Publicly available business contact information and phone numbers</li>
            <li>Company size, revenue, industry, technologies</li>
          </ul>
          <p>
            We do not guarantee the accuracy or completeness of third-party data
            and recommend users verify information before use.
          </p>

          <h2>How We Use Your Information</h2>
          <ul>
            <li>Provide and improve our services</li>
            <li>Personalize user experience</li>
            <li>Process payments</li>
            <li>Handle support requests</li>
            <li>Prevent abuse and ensure security</li>
            <li>Send platform updates and service-related communications (optional)</li>
          </ul>
          <p>Leadszora does not sell, rent, or trade personal data for marketing purposes.</p>

          <h2>Cookies</h2>
          <ul>
            <li>Improve user experience</li>
            <li>Remember preferences</li>
            <li>Analyze traffic</li>
            <li>Identify returning visitors</li>
          </ul>
          <p>You may disable cookies in your browser at any time.</p>

          <h2>Sharing of Information</h2>
          <ul>
            <li>We do not sell personal data</li>
            <li>With trusted service providers</li>
            <li>For legal compliance</li>
            <li>For fraud prevention and security</li>
            <li>With your consent (when required)</li>
          </ul>

          <h2>Data Security</h2>
          <ul>
            <li>Encrypt sensitive information</li>
            <li>Monitor our systems</li>
            <li>Prevent unauthorized access</li>
          </ul>
          <p>We use industry-standard security practices including SSL encryption.</p>

          <h2>Your Rights (GDPR / CCPA)</h2>
          <ul>
            <li>Access your stored information</li>
            <li>Request deletion</li>
            <li>Update or correct your data</li>
            <li>Opt-out of marketing</li>
            <li>Request a copy of your data</li>
            <li>Withdraw consent anytime</li>
          </ul>
          <p>
            To request any of the above, contact us at{' '}
            <a href="mailto:support@leadszora.com">support@leadszora.com</a>
          </p>

          <h2>Contact Data Usage &amp; Compliance</h2>
          <p>
            Leadszora provides access to business contact data intended for lawful and
            ethical marketing purposes only. Users are solely responsible for ensuring
            compliance with applicable digital marketing and data protection laws,
            including but not limited to, GDPR, CCPA, and other local regulations.
          </p>
          <p>
            Leadszora does not encourage unsolicited bulk messaging, or misuse of
            contact data.
          </p>

          <h2>Changes to This Policy</h2>
          <p>
            We may update this privacy policy occasionally. The latest version
            will always be posted on this page.
          </p>
        </article>
      </main>

      <footer className="pp-footer">
        <div className="pp-footer__inner">
          <span>Copyright &copy; Leadszora 2026</span>
          <nav aria-label="Legal links">
            <a href="/">Home</a>
            <span>|</span>
            <a href="/2.0privacy-policy">Privacy Policy</a>
            <span>|</span>
            <a href="/2.0Terms-of-Service">Terms &amp; Conditions</a>
            <span>|</span>
            <a href="/2.0Earning-Disclaimer">Earning Disclaimer</a>
            <span>|</span>
            <a href="/2.0Contact-Us">Contact Us</a>
          </nav>
        </div>
      </footer>
    </div>
  )
}
